import { render } from "./groupButtons.vue?vue&type=template&id=37e280aa"
import script from "./groupButtons.vue?vue&type=script&setup=true&lang=js"
export * from "./groupButtons.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/v2/modules/contacts/pages/groups/list/components/groupButtons.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "37e280aa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('37e280aa', __exports__)) {
    console.log('reload')
    api.reload('37e280aa', __exports__)
  }
  
  module.hot.accept("./groupButtons.vue?vue&type=template&id=37e280aa", () => {
    console.log('re-render')
    api.rerender('37e280aa', render)
  })

}


export default __exports__